import React, { useEffect } from 'react';
import connect from 'react-redux/es/connect/connect';
import {clearSession} from '../../stores/ClearSession/ClearSessionActions';
import {savePaymentInfo} from '../../stores/PaymentInfoParam/PaymentInfoParamActions';
import {savePaymentSuccess} from '../../stores/PaymentSuccessParam/PaymentSuccessParamActions';
import {savePaymentError} from '../../stores/PaymentErrorParam/PaymentErrorParamActions';
import {getPaymentInfo} from '../../api/Payment';
import BILLoader from '../../components/BILLoader/BILLoader';
import {redirectTo} from '../../utils/RedirectUtil'
import {handleServerError} from '../../api/Payment';
import {
   SCA_REQUIRED, 
   ACCOUNT_SELECTION_REQUIRED, 
   SCA_EXEMPTION_TO_BE_VALIDATED,
   CANCELLATION_SCA_REQUIRED,
   VALIDATION_SUCCESS,
   VALIDATION_FAILURE,
   PAYMENT_CANCELED,
   PAYMENT_EXPIRED} from '../../constants/StateConstants';
import './index.less';

//// JS MAIN
const Execution = (props) => {

   const {language, history} = props;

   useEffect(() => {
      props.clearSession();
      getPaymentInfo(props.match.params.paymentReferenceParam, language)
      .then((response) => applyStateRedirect(props, response))
      .catch((error) => handleServerError(error, language, history))
   }, []);

   return (
      <div className="intl-spinner-container">
         <BILLoader />
      </div>
   )
}

//// JS FUNCTIONS
function applyStateRedirect(props, response) {

   const {language, history, savePaymentInfo} = props;
   const data = response.data;

   if (data) {
      savePaymentInfo(data)
      executeStategyRedirect(props, data);
   } else {
      handleServerError({error: "unexpected.error"}, language, history)
   }
}

function executeStategyRedirect(props, data) {

   const {language, history, savePaymentSuccess, savePaymentError} = props;
   switch(data.state) {
      case SCA_REQUIRED:
      case SCA_EXEMPTION_TO_BE_VALIDATED:
      case CANCELLATION_SCA_REQUIRED:
         redirectTo(history, `/${language}/summary`)
         break;

      case ACCOUNT_SELECTION_REQUIRED:
         redirectTo(history, `/${language}/accounts`)
         break;

      case VALIDATION_SUCCESS:
         savePaymentSuccess('payment.initiated.message')
         redirectTo(history, `/${language}/result?status=success`)
         break;

      case PAYMENT_CANCELED:
         savePaymentSuccess('payment.cancelled.message')
         redirectTo(history, `/${language}/result?status=success`)
         break;
      case PAYMENT_EXPIRED:
         savePaymentError('expired.error')
         redirectTo(history, `/${language}/result?status=fail`)
         break;

      case VALIDATION_FAILURE:
         savePaymentError(data.errorReason ? data.errorReason : null)
         redirectTo(history, `/${language}/result?status=fail`)
         break; 

      default:
         handleServerError({error: "unexpected.error"}, language, history)
    }
}

//// JS REDUX
const mapStateToProps = (state) => ({
   language: state.intl.locale
});

const mapDispatchToProps = {
   savePaymentInfo,
   savePaymentSuccess,
   savePaymentError,
   clearSession,
};

export default connect(mapStateToProps, mapDispatchToProps)(Execution);
